module.exports = __webpack_public_path__ + "fonts/subset-IskraFreefont.6aa9f8e.woff2";